import script from "./activityLottery.vue?vue&type=script&setup=true&lang=js"
export * from "./activityLottery.vue?vue&type=script&setup=true&lang=js"

import "./activityLottery.vue?vue&type=style&index=0&id=09cbe34c&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09cbe34c"]])

export default __exports__